import React from 'react'
import './featureCard.css'

function INCSUBFeatureCard({obj}) {
  return (
    <div className='INCSUBFeatureCard'>
        <div className='INCSUBFeatureCard_img_hold' style={{background: obj.bg}}>{obj.svg}</div>
        <div className='INCSUBFeatureCard_heading'>{obj.heading}</div>
        <p className='INCSUBFeatureCard_para'>{obj.para}</p>
    </div>
  )
}

export default INCSUBFeatureCard;
